import { Badge, BoxProps, useTokens } from '@mezzoforte/forge';

const { shadows } = useTokens.huutokaupat;

export default function OverlayBadge(props: React.ComponentProps<typeof Badge> & BoxProps) {
  return (
    <Badge
      boxShadow={shadows.box}
      zIndex="docked"
      {...props}
    />
  );
}
